<template>
	<div>
		
		<card>
			<h6 v-if="this.pbID"> БП id: {{ this.pbID }}</h6>
			<ReFormPrinter 
				:masFormConfig="masAllFormParams" 
				:objSaveApiMethod="currentApiFormMethod"
				:SuccessGo="SuccessGo"/>
		</card>
		<card v-if="operationType == 'edit'">
			<ReFormPrinter 
				:masFormConfig="masAllFormParamsLeadPlugin" 
				:objSaveApiMethod="currentApiFormMethodLeadPlugin"
				:SuccessGo="SuccessGo"/>
		</card>
		<card v-if="operationType == 'edit'">
			<ReBPCheckLead v-model="bpId"/>
		</card>		
	</div>
</template>

<script>
	import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
	import ReBPCheckLead from './ReBPCheckLead.vue';
	export default {
		name: 'ReBPEdit',
		components: {
			ReFormPrinter,
			ReBPCheckLead,
		},
		props: {
			bpId: {
				type: String, 
				default: '0'
			},
			operationType: String, 
		},
		data () {
			return {
				ver: 1,
				masAllFormParams: this.currentFormConfig(),
				masAllFormParamsLeadPlugin: this.currentFormConfigLeadPlugin(),
				currentApiFormMethodLeadPlugin: {apiMethod:'INSUPD',apiParam:{obj:'../plugins/leads2bpservice' ,flt:{'BP_ID':this.bpId},uData:[]}},
				pbID: '',
			}
		},
		computed: {
			currentApiFormMethod: function(){
				if(this.operationType == 'edit'){
					return {apiMethod:'UPD',apiParam:{obj:'BP' ,flt:{id:this.bpId},uData:[]}};
				} else if(this.operationType == 'add'){
					return {apiMethod:'UPD',apiParam:{obj:'BP' ,flt:{id:0},iData:[]}};
				}
				return {apiMethod:'UPD',apiParam:{obj:'BP' ,flt:{id:this.bpId},uData:[]}};
			}
		},
		methods: {
			currentFormConfig(){
				if(this.operationType == 'edit'){
					this.$GVO.ApiCall('GET_FORM_BP',{obj:'BP',flt:{id:this.bpId}})
						.then((objApi) => {
							if(objApi.success){
								// console.log('BP.GET_FORM_BP',this.$GVO.unlinkObject(objApi.config));
								this.masAllFormParams = objApi.config;
							}
						})
						.catch(errorObjApi => console.error(errorObjApi));
				}else if(this.operationType == 'add'){
					this.$GVO.ApiCall('GET_FORM_BP',{obj:'BP',flt:{id:0}})
						.then((objApi) => {
							if(objApi.success){
								this.masAllFormParams = objApi.config;
							}
						})
						.catch(errorObjApi => console.error(errorObjApi));
				}
				return [];
			},
			SuccessGo(evt, ObjApi){
				if(ObjApi && ObjApi.insertid){
					this.$router.push({path: '/data/settings/bp_editor/id/'+ObjApi.insertid});
				}else{
					this.$router.back();
				}
			},
			currentFormConfigLeadPlugin(){
				if(this.operationType == 'edit'){
					this.$GVO.ApiCall('GET_FORM_BP_LEADS',{obj:'BP',flt:{'BP_ID':this.bpId}})
						.then((objApi) => {
							if(objApi.success){
								this.masAllFormParamsLeadPlugin = objApi.config;
								//console.log(this.masAllFormParamsLeadPlugin);
							}
						})
						.catch(errorObjApi => console.error(errorObjApi));
				}
				return [];
			},
		},
		mounted() {
			// this.getBPProlifeName(this.profileCode);
			this.pbID =this.$route.params.bp_id;
			// console.log(this.pbID);
		}

		
	}
</script>
<style scoped>

</style>
